import { render, staticRenderFns } from "./TipoMercadoria.vue?vue&type=template&id=11239530&scoped=true&"
import script from "./TipoMercadoria.vue?vue&type=script&lang=js&"
export * from "./TipoMercadoria.vue?vue&type=script&lang=js&"
import style0 from "./TipoMercadoria.vue?vue&type=style&index=0&id=11239530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11239530",
  null
  
)

export default component.exports